import { assert } from '@varos/util-typescript';
import { ChatItemReadAggregate } from './chatReadModel';
import { ReportingShellLoaderBaseConfig } from '../../../../base';
import { ChatItemReadLoader } from './chatReadInterface';

export function createChatItemReadLoader(
    config: ReportingShellLoaderBaseConfig
): ChatItemReadLoader {
    const {
        repository: { research: repository },
    } = config;
    return {
        useLoad(context, props): ChatItemReadAggregate {
            return {
                tool: props.item.tool,
                result: props.item.result,
            };
        },
    };
}
